export const GOOGLE_FONTS_API_KEY = 'AIzaSyDeqvuf3NM18PoltQ55wCQbCC-JRbqILZo';
